import cloneDeep from 'lodash/cloneDeep'
import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_AIRPORTS_FILTERS_UI,
} from '../../../actions/actionTypes'

/* AIRPORTS */
export const airportsFilter = (state = [], action) => {
  const { type, payload = [], meta = {}, entity } = action

  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      // this code hads deeper nesting and cannot do a shallow copy
      return payload.AIRPORTS.map(slice => cloneDeep(slice))

    case SET_CURRENT_FILTER_INFO:
      return payload.airportsFilter.map(slice => cloneDeep(slice))

    case UPDATE_AIRPORTS_FILTERS_UI:
      const [airportCode, shouldAdd] = payload
      return state.map((airportObj, index) => {
        return {
          destinationAirports: airportObj.destinationAirports.map(airport => {
            if (meta.isNoneClick && entity === 'dest') {
              airport.checked = false
            } else if (meta.isAllClick && entity === 'dest') {
              airport.checked = true
            } else if (
              (meta.isOnlyClick && index === 0 && entity === 'dest') ||
              (meta.isOnlyClick && index === 1 && entity === 'origin')
            ) {
              airport.checked = airport.value === airportCode
            } else {
              airport.checked =
                airport.value === airportCode ? shouldAdd : airport.checked
            }

            return { ...airport }
          }),
          originAirports: airportObj.originAirports.map(airport => {
            if (meta.isNoneClick && entity === 'origin') {
              airport.checked = false
            } else if (meta.isAllClick && entity === 'origin') {
              airport.checked = true
            } else if (
              (meta.isOnlyClick && index === 0 && entity === 'origin') ||
              (meta.isOnlyClick && index === 1 && entity === 'dest')
            ) {
              airport.checked = airport.value === airportCode
            } else {
              airport.checked =
                airport.value === airportCode ? shouldAdd : airport.checked
            }
            return { ...airport }
          }),
        }
      })

    default:
      return state
  }
}
